import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const TERMS = [
  {
    title: "Booking Time & Late Arrivals",
    body: "Your booking time includes setup, shoot and pack-up. The slot begins at the confirmed booking time, regardless of the client's arrival time, and ends when the last member of the team exits the studio. Late arrival does not extend the booking — the original start and end times remain applicable.",
  },
  {
    title: "Additional Time",
    body: "Any time beyond the booked slot will be charged at ₹700 per hour, subject to studio availability. Additional time required for packing up or data backup will also be chargeable.",
  },
  {
    title: "Booking & Payment",
    body: "A 50% advance payment is required to confirm the booking. The remaining payment must be completed at least 3 days before the shoot.",
  },
  {
    title: "Security Deposit",
    body: "A refundable security deposit of ₹5,000 is required before the shoot. It will be refunded after the booking, subject to inspection of the studio. Charges for any damage, loss, excessive cleaning or violation of studio policies may be deducted from the deposit.",
  },
  {
    title: "Cancellation & Rescheduling",
    body: "Payments made towards a cancelled booking are non-refundable. However, the booking may be rescheduled once within 2 months of the original booking date, subject to studio availability and mutual confirmation.",
  },
  {
    title: "Studio Property, Walls & Backdrops",
    body: "Clients are responsible for the proper use of all studio walls, backdrops, furniture, props and other property. Any damage or loss caused during the booking will be charged at the applicable repair or replacement cost. Nailing, drilling, painting, sticking, taping or making any alteration to studio walls, sets or backdrops is not permitted without prior approval from the Room 9 team.",
  },
  {
    title: "Footwear & Cleaning",
    body: "Shoe protection/taping must be used wherever required, particularly while using backdrops and designated studio setups. The studio must be handed back in substantially the same condition in which it was provided — marks, stains, damage or excessive cleaning may be charged accordingly.",
  },
  {
    title: "Food, Smoking & Prohibited Activities",
    body: "Smoking and alcohol are strictly prohibited within the studio. Cooking and consumption of non-vegetarian food are also not permitted on the premises. The studio cannot be used for any unlawful activity or for the creation of content prohibited under applicable law.",
  },
  {
    title: "Personal Belongings & Identification",
    body: "Clients are responsible for their own equipment and personal belongings. Room 9 will not be responsible for loss, theft or damage to personal property, except where liability cannot legally be excluded. The person making the booking may be required to provide a valid government-issued photo ID and address proof.",
  },
  {
    title: "Studio Access & Acceptance of Terms",
    body: "The Room 9 team may enter the studio during a booking when reasonably required for assistance, supervision, maintenance, safety or emergencies. Confirmation of a booking and/or payment of the advance will constitute acceptance of these Terms & Conditions.",
  },
];

export const Terms = () => (
  <section id="terms" data-testid="terms-section" className="py-20 bg-bg border-b border-line">
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="mb-12">
        <span className="label-caps text-forest block mb-2">Room 9 — Terms & Conditions</span>
        <h2 data-testid="terms-heading" className="heavy-heading text-3xl sm:text-4xl font-extrabold text-ink mb-3">
          Good to know before you book.
        </h2>
        <p className="text-sm text-muted-g">
          By confirming a booking with Room 9, the client agrees to the following:
        </p>
      </div>
      <Accordion type="single" collapsible data-testid="terms-accordion" className="bg-white rounded-xl border border-line-2 px-6">
        {TERMS.map((t, i) => (
          <AccordionItem key={t.title} value={`term-${i + 1}`} className="border-line">
            <AccordionTrigger
              data-testid={`terms-trigger-${i + 1}`}
              className="text-left text-sm font-bold text-ink hover:text-forest hover:no-underline py-4"
            >
              <span className="flex items-center gap-3">
                <span className="font-mono text-xs text-muted-g">{String(i + 1).padStart(2, "0")}</span>
                {t.title}
              </span>
            </AccordionTrigger>
            <AccordionContent data-testid={`terms-content-${i + 1}`} className="text-sm text-muted-gd leading-relaxed">
              {t.body}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);
